import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {isCopilot} from '@github-ui/assignees/copilot-user'
import {isReviewEffortValue, reviewEffortLabel} from '@github-ui/copilot-code-review-controls/review-effort'

export function ReviewRequestText({info}: {info: IssueEventInfo}) {
  const {eventType, reviewerLogin, reviewerTeamSlug, reviewEffortLevel} = info
  const reviewer = reviewerLogin ?? reviewerTeamSlug
  if (!reviewer) return <>{eventType === 'review_requested' ? 'requested a review' : 'removed the review request'}</>

  const effortLabel =
    eventType === 'review_requested' &&
    reviewerLogin &&
    isCopilot(reviewerLogin) &&
    isReviewEffortValue(reviewEffortLevel)
      ? reviewEffortLabel(reviewEffortLevel).toLowerCase()
      : undefined

  if (eventType === 'review_requested') {
    const article = effortLabel && /^[aeiou]/.test(effortLabel) ? 'an' : 'a'
    const reviewRequestText = effortLabel
      ? `requested ${article} ${effortLabel} review from `
      : 'requested a review from '

    return (
      <>
        {reviewRequestText}
        <strong>{reviewer}</strong>
      </>
    )
  }

  return (
    <>
      removed the review request for <strong>{reviewer}</strong>
    </>
  )
}
